export const isString = (value) => {
  return value instanceof String || typeof value === 'string';
};

export const isBlankOrNullString = (value) => {
  if (value == null) return true;
  if (isString(value)) return value.trim() === '';
  return false;
};

export const isNotBlankOrNullString = (value) => {
  if (value == null || value === 'null') return false;
  if (isString(value)) return value.trim() !== '';
  return false;
};

export const isMobilePhoneNumber = (/*string*/ value) => {
  if (value != null && isString(value)) {
    const _value = value.trim();
    const regexp = /^69[0-9]{8}$/gi;
    return _value.length === 10 && regexp.test(_value);
  }
  return false;
};

export const isFixedPhoneNumber = (/*string*/ value) => {
  if (value != null && isString(value)) {
    const _value = value.trim();
    const regexp = /^2[0-9]{9}$/gi;
    return _value.length === 10 && regexp.test(_value);
  }
  return false;
};

export const isValidEmailFormat = (/*string*/ value) => {
  if (value != null && isString(value)) {
    // noinspection RegExpRedundantEscape
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value.trim()
    );
  }
  return false;
};

export const isValidPhoneNumberFormat = (/*string*/ value) => {
  if(value == null || !isString(value)) return false
  return /^\s*(\+\d{1,3}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}\s*$/gm.test(value.trim())
}
